import React, { createContext, useContext, useState, useCallback } from 'react';

// ── Full currency list ──
export const CURRENCIES = [
    { code: 'INR', symbol: '₹', name: 'Indian Rupee', flag: '🇮🇳' },
    { code: 'USD', symbol: '$', name: 'US Dollar', flag: '🇺🇸' },
    { code: 'EUR', symbol: '€', name: 'Euro', flag: '🇪🇺' },
    { code: 'GBP', symbol: '£', name: 'British Pound', flag: '🇬🇧' },
    { code: 'JPY', symbol: '¥', name: 'Japanese Yen', flag: '🇯🇵' },
    { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', flag: '🇨🇳' },
    { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', flag: '🇦🇺' },
    { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar', flag: '🇨🇦' },
    { code: 'CHF', symbol: '₣', name: 'Swiss Franc', flag: '🇨🇭' },
    { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar', flag: '🇸🇬' },
    { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', flag: '🇦🇪' },
    { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal', flag: '🇸🇦' },
    { code: 'HKD', symbol: 'HK$', name: 'Hong Kong Dollar', flag: '🇭🇰' },
    { code: 'KRW', symbol: '₩', name: 'South Korean Won', flag: '🇰🇷' },
    { code: 'MYR', symbol: 'RM', name: 'Malaysian Ringgit', flag: '🇲🇾' },
    { code: 'THB', symbol: '฿', name: 'Thai Baht', flag: '🇹🇭' },
    { code: 'IDR', symbol: 'Rp', name: 'Indonesian Rupiah', flag: '🇮🇩' },
    { code: 'PHP', symbol: '₱', name: 'Philippine Peso', flag: '🇵🇭' },
    { code: 'VND', symbol: '₫', name: 'Vietnamese Dong', flag: '🇻🇳' },
    { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', flag: '🇧🇷' },
    { code: 'MXN', symbol: 'MX$', name: 'Mexican Peso', flag: '🇲🇽' },
    { code: 'ZAR', symbol: 'R', name: 'South African Rand', flag: '🇿🇦' },
    { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone', flag: '🇳🇴' },
    { code: 'SEK', symbol: 'kr', name: 'Swedish Krona', flag: '🇸🇪' },
    { code: 'DKK', symbol: 'kr', name: 'Danish Krone', flag: '🇩🇰' },
    { code: 'NZD', symbol: 'NZ$', name: 'New Zealand Dollar', flag: '🇳🇿' },
    { code: 'TRY', symbol: '₺', name: 'Turkish Lira', flag: '🇹🇷' },
    { code: 'RUB', symbol: '₽', name: 'Russian Ruble', flag: '🇷🇺' },
    { code: 'PKR', symbol: '₨', name: 'Pakistani Rupee', flag: '🇵🇰' },
    { code: 'BDT', symbol: '৳', name: 'Bangladeshi Taka', flag: '🇧🇩' },
    { code: 'LKR', symbol: 'Rs', name: 'Sri Lankan Rupee', flag: '🇱🇰' },
    { code: 'NPR', symbol: 'Rs', name: 'Nepalese Rupee', flag: '🇳🇵' },
    { code: 'MMK', symbol: 'K', name: 'Myanmar Kyat', flag: '🇲🇲' },
    { code: 'EGP', symbol: 'E£', name: 'Egyptian Pound', flag: '🇪🇬' },
    { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', flag: '🇳🇬' },
    { code: 'KES', symbol: 'KSh', name: 'Kenyan Shilling', flag: '🇰🇪' },
    { code: 'GHS', symbol: '₵', name: 'Ghanaian Cedi', flag: '🇬🇭' },
    { code: 'QAR', symbol: 'QR', name: 'Qatari Riyal', flag: '🇶🇦' },
    { code: 'KWD', symbol: 'KD', name: 'Kuwaiti Dinar', flag: '🇰🇼' },
    { code: 'BHD', symbol: 'BD', name: 'Bahraini Dinar', flag: '🇧🇭' },
    { code: 'OMR', symbol: 'RO', name: 'Omani Rial', flag: '🇴🇲' },
    { code: 'ILS', symbol: '₪', name: 'Israeli Shekel', flag: '🇮🇱' },
    { code: 'PLN', symbol: 'zł', name: 'Polish Złoty', flag: '🇵🇱' },
    { code: 'CZK', symbol: 'Kč', name: 'Czech Koruna', flag: '🇨🇿' },
    { code: 'HUF', symbol: 'Ft', name: 'Hungarian Forint', flag: '🇭🇺' },
    { code: 'RON', symbol: 'lei', name: 'Romanian Leu', flag: '🇷🇴' },
    { code: 'CLP', symbol: 'CL$', name: 'Chilean Peso', flag: '🇨🇱' },
    { code: 'COP', symbol: 'CO$', name: 'Colombian Peso', flag: '🇨🇴' },
    { code: 'PEN', symbol: 'S/.', name: 'Peruvian Sol', flag: '🇵🇪' },
    { code: 'ARS', symbol: 'AR$', name: 'Argentine Peso', flag: '🇦🇷' },
];

const LOCAL_KEY = 'budgetify_currency';
const DEFAULT = 'INR';

export const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
    const [currencyCode, setCurrencyCodeState] = useState(() => {
        return localStorage.getItem(LOCAL_KEY) || DEFAULT;
    });

    const setCurrency = useCallback((code) => {
        localStorage.setItem(LOCAL_KEY, code);
        setCurrencyCodeState(code);
    }, []);

    const currency = CURRENCIES.find(c => c.code === currencyCode) || CURRENCIES[0];

    return (
        <CurrencyContext.Provider value={{ currency, currencyCode, setCurrency, CURRENCIES }}>
            {children}
        </CurrencyContext.Provider>
    );
}

// Convenience hook
export function useCurrency() {
    return useContext(CurrencyContext);
}
